module.exports = __webpack_public_path__ + "img/tab-withdraw.872b8350.png";